<template>
  <div class="j-container j-container-box-shadow  profile-container">
    <img
      class="img"
      v-if="first && first.imgUrl"
      :src="baseUrl + first.imgUrl"
    />
    <div v-if="first">
      <div class="j-title title">
        {{ first.title }}
      </div>
      <div class="j-content desc" v-html="first.articleTxt"></div>
    </div>
    <div v-if="loaded && !first" class="j-coming-soon j-content">
      {{ $t('common.coming_soon') }}
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { baseUrl } from '@/utils/constants';

export default defineComponent({
  name: 'CompanyProfile',
  data() {
    return {
      baseUrl
    };
  },
  props: {
    first: {
      required: true,
      default: () => {
        return null;
      }
    },
    loaded: {
      required: true,
      type: Boolean,
      default: false
    }
  }
});
</script>

<style lang="scss" scoped>
.profile-container {
  position: relative;
  margin-top: -70px;
  z-index: 1;
  padding: 50px;
  background: #ffffff;
  margin-bottom: 70px;
  min-height: 400px;

  .title {
    margin-bottom: 30px;
  }

  img {
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    width: 100%;
    max-height: 100%;
    z-index: -1;
  }
}
</style>
